import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'base',
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginView.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue')
  },
  {
    path: '/select-ba-type',
    name: 'select-ba-type',
    component: () => import(/* webpackChunkName: "about" */ '../views/SelectBaTypeView.vue')
  },
  {
    path: '/create-ba/:code',
    name: 'create-ba',
    component: () => import(/* webpackChunkName: "about" */ '../views/CreateBaFormView.vue')
  },
  {
    path: '/edit-ba/:code/:id',
    name: 'edit-ba',
    component: () => import(/* webpackChunkName: "about" */ '../views/CreateBaFormView.vue')
  },
  {
    path: '/create-ba-blanket/:code',
    name: 'create-ba-blanket',
    component: () => import(/* webpackChunkName: "about" */ '../views/CreateBaBlanketFormView.vue')
  },
  {
    path: '/detail-ba-blanket/:id',
    name: 'detail-ba-blanket',
    component: () => import(/* webpackChunkName: "about" */ '../views/DetailBaBlanketView.vue')
  },
  {
    path: '/detail-ba/:id',
    name: 'detail-ba',
    component: () => import(/* webpackChunkName: "about" */ '../views/DetailBaView.vue')
  },
  {
    path: '/approval/:type',
    name: 'approval',
    component: () => import(/* webpackChunkName: "about" */ '../views/ApprovalView.vue')
  },
  {
    path: '/draft',
    name: 'draft',
    component: () => import(/* webpackChunkName: "about" */ '../views/DraftView.vue')
  },
  {
    path: '/proses/ba/:id/:action/:token',
    name: 'prosesBa',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProsesBa.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "about" */ '../views/UsersView.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
